// src/context/LanguageContext.js
import React, { createContext, useState, useContext } from 'react';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Detecta o idioma do navegador
    const browserLang = navigator.language.split('-')[0];
    return ['en', 'fr', 'pt', 'zh', 'zh_tw'].includes(browserLang) ? browserLang : 'en';
  });

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);